export default "__VITE_ASSET__3d0be95d__"